export default __webpack_public_path__ + "static/media/swift.8a92ca47.svg";